







import { Component, Prop, Vue } from 'vue-property-decorator';

import CoverNav from '@/components/homescapes/hs002/CoverNav.vue';
import CoverCard from '@/components/homescapes/hs002/CoverCard.vue';

export enum CoverVersion {
  HOME = 'home',
  PAINT = 'paint',
  KATHERIN = 'katherin',
}

@Component({
  components: {
    CoverCard,
    CoverNav,
  },
})
export default class CoverSection extends Vue {
  @Prop({ type: String })
  readonly version!: string;

  get versions(): Record<string, string> {
    const {
      'version-home': home,
      'version-paint': paint,
      'version-katherin': katherin,
    } = this.$style;

    return {
      [CoverVersion.HOME]: home,
      [CoverVersion.PAINT]: paint,
      [CoverVersion.KATHERIN]: katherin,
    };
  }

  get classes() {
    const { root } = this.$style;

    const version = this.versions[this.version];

    return [root, version];
  }
}
